import { render, staticRenderFns } from "./VisualizationPieChart.vue?vue&type=template&id=b0161fa8&scoped=true"
import script from "./VisualizationPieChart.vue?vue&type=script&lang=js"
export * from "./VisualizationPieChart.vue?vue&type=script&lang=js"
import style0 from "./VisualizationPieChart.vue?vue&type=style&index=0&id=b0161fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0161fa8",
  null
  
)

export default component.exports